import { render, staticRenderFns } from "./distribute.vue?vue&type=template&id=6a26cabf&scoped=true"
import script from "./distribute.vue?vue&type=script&lang=js"
export * from "./distribute.vue?vue&type=script&lang=js"
import style0 from "./distribute.vue?vue&type=style&index=0&id=6a26cabf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a26cabf",
  null
  
)

export default component.exports